



















import {Component, Inject, Prop, Vue} from 'vue-property-decorator';

type Value = number | [number, number] | null;
import {Photo} from '@/model/api';
import RealEstateEstimate from '@/model/estimates/RealEstateEstimate';
import {UploadStarted} from './events';

@Component
export default class PhotoUpload extends Vue {
    @Inject()
    public model: RealEstateEstimate;

    protected highlighted: boolean = false;

    protected errors: string[] = [];

    private nextUploadId: number = 0;

    private readonly allowedMimeTypes = ['image/jpeg', 'image/gif', 'image/png', 'image/webp'];


    public fileWasUploaded(response: Photo): void {
        this.$emit('uploaded', response);
    }

    protected highlight(event?: DragEvent): void {
        if (event !== undefined) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.highlighted = true;
    }

    protected unHighlight(event?: DragEvent): void {
        if (event !== undefined) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.highlighted = false;
    }

    protected onDrop(event: DragEvent): void {
        this.unHighlight();
        event.preventDefault();
        event.stopPropagation();

        const transfer = event.dataTransfer;

        if (transfer === null) {
            return;
        }

        this.uploadFiles(transfer.files);
    }

    protected onFileInputChange(event: InputEvent): void {
        const files = (event.target as HTMLInputElement).files;

        if (files === null) {
            return;
        }

        this.uploadFiles(files);
    }

    private uploadFiles(files: FileList): void {
        this.errors = [];

        [...files].forEach(file => {
            if (! this.allowedMimeTypes.includes(file.type)) {
                this.errors.push(`Typ souboru <strong>${file.name}</strong> není podporován.`);
                return;
            }
            this.uploadFile(file);
        });
    }

    private uploadFile(file: File): void {
        const upload = this.initializeUpload(file);

        this.$emit('started', upload);

        this.model.uploadPhoto(file)
            .then(photo => this.$emit('uploaded', {uploadId: upload.uploadId, ...photo}));
    }

    private initializeUpload(file: File): UploadStarted {
        return {
            uploadId: this.nextUploadId++,
            file,
        };
    }
}
